import { AmplifyCapabilities } from '../../../enums';
import { STUB_ORG_CONTEXT } from '../../../fixture/context';

const baseCapability: CMxCommonApp.Capability = {
  on: {
    value: false,
    reasons: []
  },
  actionable: {
    value: false,
    reasons: []
  }
};

const holdCase: CMxAPI.HoldCaseResponse = {
  hold_reason: '',
  comment: '',
  coding_manager_id: ''
};

export const cursorAPIContext: CMxCommonApp.CursorAPIContext = {
  worklistContext: {},
  servicedeskMode: false,
  workitemId: '',
  sessionId: '',
  qaCollectionUuid: '',
  launchConfigServiceLine: ''
};

const baseCapabilities = {
  noteUnavailableReason: { ...baseCapability },
  coding: { ...baseCapability },
  improvements: { ...baseCapability },
  pagination: { ...baseCapability },
  actionMenuCancelButton: { ...baseCapability },
  submitCase: { ...baseCapability },
  viewOnlyCase: { ...baseCapability },
  holdCase: { ...baseCapability },
  removeHoldCase: { ...baseCapability },
  toggleCaseComment: { ...baseCapability },
  toggleChargeableCase: { ...baseCapability },
  caseEdit: { ...baseCapability },
  actionMenu: { ...baseCapability },
  generalCancelButton: { ...baseCapability },
  improvementsAction: { ...baseCapability },
  productivityTracker: { ...baseCapability },
  oldCaseLoadedAlert: { ...baseCapability },
  previousSentCaseAlert: { ...baseCapability },
  servicedeskAction: { ...baseCapability },
  mergeCapability: { ...baseCapability },
  splitCapability: { ...baseCapability },
  createCase: { ...baseCapability },
  coderFeedback: { ...baseCapability },
  timelineInfiniteLoad: { ...baseCapability },
  attachDocs: { ...baseCapability },
  diagnosisCodeSuggestion: { ...baseCapability },
  coderNotes: { ...baseCapability },
  actionBarSelectMultipleWorkitems: { ...baseCapability },
  viewScoreDetail: { ...baseCapability }
};

const capabilities: Accelerate.CapabilitiesState<AmplifyCapabilities> = {
  userContext: { ...STUB_ORG_CONTEXT },
  roles: [],
  holdCaseStatus: { ...holdCase },
  cursorAPIContext: { ...cursorAPIContext },
  parentCaserunUid: null,
  parentCase: false,
  activeItem: {} as CMxAPI.CaseRun,
  submitInProgress: false,
  activeServiceLineName: '',
  capabilities: {
    noteUnavailableReason: { ...baseCapability },
    coding: { ...baseCapability },
    improvements: { ...baseCapability },
    pagination: { ...baseCapability },
    actionMenuCancelButton: { ...baseCapability },
    submitCase: { ...baseCapability },
    viewOnlyCase: { ...baseCapability },
    holdCase: { ...baseCapability },
    removeHoldCase: { ...baseCapability },
    toggleCaseComment: { ...baseCapability },
    toggleChargeableCase: { ...baseCapability },
    caseEdit: { ...baseCapability },
    actionMenu: { ...baseCapability },
    generalCancelButton: { ...baseCapability },
    improvementsAction: { ...baseCapability },
    productivityTracker: { ...baseCapability },
    oldCaseLoadedAlert: { ...baseCapability },
    previousSentCaseAlert: { ...baseCapability },
    servicedeskAction: { ...baseCapability },
    mergeCapability: { ...baseCapability },
    splitCapability: { ...baseCapability },
    createCase: { ...baseCapability },
    coderFeedback: { ...baseCapability },
    timelineInfiniteLoad: { ...baseCapability },
    attachDocs: { ...baseCapability },
    diagnosisCodeSuggestion: { ...baseCapability },
    coderNotes: { ...baseCapability },
    transactionV2: { ...baseCapability },
    actionBarSelectMultipleWorkitems: { ...baseCapability },
    getCaseRunWithRefresh: { ...baseCapability },
    useProviderDirectoryLocations: { ...baseCapability },
    codeSourcesFeatures: { ...baseCapability },
    lateCaseClearNotification: { ...baseCapability },
    viewScoreDetail: { ...baseCapability }
  },
  excludeCasePermissionsConfig: null
};

export { capabilities, baseCapabilities };
